import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter, Input, Output,
  OnInit, OnDestroy, ViewChild
} from '@angular/core';
import { Observable ,  BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

import { SearchModel } from 'shared/search/search.model';

import { SearchWidgetComponent } from 'shared/search-widget/search-widget.component';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';

import { BrandService } from 'shared/brand/brand.service';
import { ProductsSearchService } from './products-search.service';
import {ProductPanelComponent} from '../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'products-search',
  templateUrl: 'products-search.component.html',
  styleUrls: ['products-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsSearchComponent extends SearchWidgetComponent implements OnInit, OnDestroy {

  @Input() declare searchResultsColumns: Array<any>;

  @Input() selectable: boolean = false;

  @Input() hasListIcon: boolean = false;

  @Input() ghostValue: string = 'products';

  @Output() openProductLists: EventEmitter<any> = new EventEmitter();

  @Output() productSelect: EventEmitter<any> = new EventEmitter();

  @ViewChild(HiddenScrollComponent, {static: false})
  hiddenScroll: HiddenScrollComponent | void;

  declare searchModel: SearchModel;
  declare _searchModel: BehaviorSubject<SearchModel>;
  declare searchModelObservable: Observable<SearchModel>;
  listIsShown: boolean = false;

  constructor(
    public searchService: ProductsSearchService,
    protected brandService: BrandService,
    private ref: ChangeDetectorRef,
  ) {
    super(
      brandService,
      searchService,
    );
  }

  startSearch() {
    if (!this.searchModelSub) {
      this.initSubscriptions();
    } else {
      this.runSearch(this.searchModel);
    }
    _.defer(() => this.hiddenScroll && this.hiddenScroll.defineContentWidth());
  }

  resetData() {
    this.searchService.deselectAll();
    this.searchService.searchResults = [];
  }

  runSearch(searchModel: SearchModel) {
    this.searchService.runSearch(this.brandService.getBrand(), searchModel)
    .subscribe((res: any) => {
      this.ref.markForCheck();
    });
  }

  ngOnInit() {
    this.searchModel = new SearchModel();
  }

  ngOnDestroy() {
    this.destroySubscriptions();
  }

  onListIconClick() {
    this.openProductLists.emit();
  }

  onRowClick(row: any) {
    this.productSelect.emit(row);
  }
}
